<template>
  <div class="flow-editor-wrap">
    <div
      class="header"
      @click="toggleFlowEditor"
    >
      <div class="label-wrapper">
        <span class="material-icons">
          {{showBody ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}
        </span>
        <span class="label">{{ $t('model.nlu-model.sidebar.flow_entities.flow_editor.flow', { 'number': index + 1 }) }}</span>
      </div>
      <div v-if="showDeleteBtn">
        <or-icon-button
          icon="delete"
          size="small"
          type="secondary"
          class="flat"
          disable-ripple
          @click.prevent.stop="onDelete"
        />
      </div>
    </div>
    <div
      v-show="showBody"
      class="body"
    >
      <or-select
        v-model="localFlow"
        class="select-flow"
        has-search
        :placeholder="$t('model.nlu-model.sidebar.flow_entities.flow_editor.selectFlow')"
        :options="nluFlows.value"
        :disabled="nluFlows.loading"
        @input="onInput"
      />
      <or-progress-linear
        v-show="nluFlows.loading"
        class="select-loader"
        color="primary"
      />
      <div class="params-list">
        <param-input
          v-for="name in paramsList"
          :value="flowParameters[name]"
          :disabled="readonly"
          :key="name"
          :label="name"
          @input="updatedParam => onFlowParamsUpdate(name, updatedParam)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import paramInput from '@/components/common/intent/param_input'

export default {
  components: { paramInput },

  created () {
    if (!_.isEmpty(this.flow)) {
      Object.assign(this.localFlow, this.flow)
      this.paramsList = Object.keys(this.localFlow.params)
    }
  },

  props: {
    flow: Object,
    index: Number,
    readonly: Boolean,
    flowsAmount: Number
  },

  computed: {
    ...mapGetters('knowledgebase/flows', ['nluFlows']),

    showDeleteBtn () {
      return this.flowsAmount > 1
    },

    flowParameters () {
      const parameters = {}
      Object.keys(this.localFlow.params).forEach(paramName => {
        parameters[paramName] = {
          value: this.localFlow.params[paramName] || '""',
          type: (this.localFlow.paramsType && this.localFlow.paramsType[paramName]) || 'custom'
        }
      })
      return parameters
    }
  },

  data () {
    return {
      showBody: true,
      localFlow: {},
      paramsList: []
    }
  },

  methods: {
    onFlowParamsUpdate (paramName, parameter) {
      this.localFlow = {
        ...this.localFlow,
        paramsType: {
          ...this.localFlow.paramsType,
          [paramName]: parameter.type
        },
        params: {
          ...this.localFlow.params,
          [paramName]: parameter.value
        }
      }
    },

    resetParams () {
      this.$set(this.localFlow, 'params', _
        .chain({ ...this.paramsList })
        .mapKeys(v => v)
        .mapValues(v => '""')
        .value())
    },

    onInput (value) {
      const newFlowEntitie = this.nluFlows.value.find(obj => obj.value === value)
      this.localFlow = _.cloneDeep(newFlowEntitie)
      this.paramsList = _.map(this.localFlow.params, 'name')
      this.resetParams()
      this.$emit('update', { index: this.index, value: this.localFlow })
    },

    onDelete () {
      // this.$emit('delete', this.localFlow.id);
      this.$emit('delete', this.index)
    },

    toggleFlowEditor () {
      this.showBody = !this.showBody
    }
  },

  watch: {
    localFlow: {
      handler (value) {
        console.log('localFlow: ', value)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
    .flow-editor-wrap {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        &:not(:last-child) {
            margin-bottom: $sp-3;
        }

        .select-flow{
            margin: 0;
            ::v-deep {
                /* default: nowrap; that can yield problems for long named flows on small screens(action btns wouldn't be visible) */
                .ui-select__display-value {
                    white-space: normal;
                }
            }
        }
        .select-loader{
            margin-bottom: 1rem;
        }

        .header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            &:hover {
                cursor: pointer;
            }

            .label-wrapper {
                display: flex;
                align-items: center;

                .label {
                    font-weight: bold;
                    font-size: 14px;
                    line-height: 16px;
                }
            }
        }

        .body {
            margin-top: $sp-3;

            .params-list {
              max-height: 200px;
              overflow: scroll;
            }
        }
    }
</style>
